import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { LocalizeAndPluralizePeriodPipe } from '@lx/shared/ui/pipes';
import { ListboxModule } from 'primeng/listbox';
import { ListboxScrollToSelectedItemDirective } from '@lx/quote-tool/lite/shared/ui/directives';
import { CourseStore } from '../../store';
import { SelectableField } from '@lx/quote-tool/lite/shared/types';
import { ListBoxComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-duration-selector',
  templateUrl: './duration-selector.component.html',
  styleUrls: ['./duration-selector.component.scss'],
  imports: [ListboxModule, FormsModule, LocalizeAndPluralizePeriodPipe, ListBoxComponent, ListboxScrollToSelectedItemDirective],
})
export class DurationSelectorComponent implements OnInit {
  @Input() dialogVisible = false;
  @Output() selectedDurationChanged = new EventEmitter<SelectableField<number>>();

  protected schoolDurations: number[] = [];
  protected selectedDuration: number | undefined;

  private readonly courseStore = inject(CourseStore);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.courseStore.availableDurations$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((availableDurations: number[]) => {
      this.schoolDurations = availableDurations;
    });

    this.courseStore.selectedDuration$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((selectedDuration: number | undefined) => {
      this.selectedDuration = selectedDuration;
    });
  }

  triggerSelectedDurationChanged(): void {
    this.selectedDurationChanged.emit({
      value: this.selectedDuration,
      fromUser: true,
    });
  }
}
